<template>
    <div>
        <TitleImage image="library" title="Biblioteca" />  
        <div class="col-md-10 col-sm-12 container">
            <div class="spacer"></div>

            <div class="row">
                <BooksFilters class="col-12 col-md-3" />

                <Books class="col-12 col-md-9" :inSection="false"/>
            </div>

            <div class="spacer"></div>

        </div>
    </div>
</template>

<script>
import Books from '@/components/Books'
import TitleImage from '@/components/TitleImage'
import BooksFilters from '@/components/BooksFilters'

export default {
    name: 'BookArchive',
    components:{
        Books,
        TitleImage,
        BooksFilters
    }
    
}
</script>